import {connect} from "react-redux";
import React from "react";
import PropTypes from "prop-types";
import Layout from './Layout';
import {replace} from "react-router-redux";
import LoadingBlocking from "../components/loading/LoadingBlocking";
import reduxRouteChanged from "../services/reduxRouteChanged";
import {passwordUpdated} from "../utils/url/passwordUpdated";
import {CreateNewPasswordForm} from "./CreateNewPasswordForm";
import {forgetPasswordCreatePassword} from "./authWithOtp/redux2";
import {datadogRum} from "@datadog/browser-rum";
import loginUrl from "../utils/url/loginUrl";
import mixpanelService from "../services/mixpanel";

@connect(
  state => {
    return {
      otpToken: state.authRoot.forgotPassword.otpToken, // token received after user verified otp
      isSuccess: state.authRoot.forgotPassword.isCreatePasswordSuccess,
      isLoading: state.authRoot.forgotPassword.isLoadingCreatePassword,
      isFail: state.authRoot.forgotPassword.isCreatePasswordFail,
      createNewPasswordError: state.authRoot.forgotPassword.createNewPasswordError,
    };
  },
  dispatch => ({
    redirect: (path) => dispatch(replace(path)),
    createNewPassword: (password, token) => dispatch(forgetPasswordCreatePassword(password, token)),
  })
)
class CreateNewPasswordController extends React.Component {

  static propTypes = {
    otpToken: PropTypes.string,
    redirect: PropTypes.func.isRequired,
    createNewPassword: PropTypes.func.isRequired,
    isSuccess: PropTypes.bool,
    isLoading: PropTypes.bool,
    isFail: PropTypes.bool,
    createNewPasswordError: PropTypes.object,
  };

  componentDidMount() {
    if (!this.props.otpToken) {
      this.props.redirect(loginUrl());
    }
  }

  componentDidUpdate(prevProps) {
    const { isSuccess, isFail, redirect, createNewPasswordError } = this.props;
    if (!prevProps.isSuccess && isSuccess) {
      datadogRum.addUserAction('Forgot password create new password success', {});
      mixpanelService.track('OTP forgot password', {step: 'create password success'});
      redirect(passwordUpdated());
    }
    if (!prevProps.isFail && isFail) {
      datadogRum.addUserAction('Forgot password create new password fail', { createNewPasswordError });
      mixpanelService.track('OTP forgot password', {step: 'create password failed'});
    }
  }

  handleSave(password) {
    this.props.createNewPassword(password, this.props.otpToken);
  }


  render() {
    return (
      <Layout>
        {this.props.isLoading && <LoadingBlocking/>}
        <CreateNewPasswordForm submitCallback={(password) => this.handleSave(password)} isFail={this.props.isFail}/>
      </Layout>
    );
  }
}

function initStore() {}

export default reduxRouteChanged(initStore, CreateNewPasswordController);



// WEBPACK FOOTER //
// ./src/auth/CreateNewPasswordController.js